
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";

@Component({})
export default class IceMountain extends Vue {
  @Prop() toolList!: any[];
  @Prop() currentIndex!: number;
  @Prop() hasAnimate!: boolean;

  iceMountain: any = null;
  mountainBg: any = null;
  iceItem: any = null;
  midImg: any = null;

  @Emit()
  getIndex(index: number) {
    return index;
  }

  async animate(el: HTMLElement, from: any, to: any, options: any) {
    const animate = el?.animate([from, to], options);
    await animate.finished;
  }

  startMountainTimeline(iceMountain: HTMLElement) {
    this.animate(
      iceMountain,
      { opacity: 0 },
      { opacity: 1 },
      {
        duration: this.hasAnimate ? 1000 : 0,
        easing: "ease"
      }
    );
  }

  async startBgTimeline(
    mountainBg: HTMLElement,
    midImg: HTMLElement,
    iceItem: HTMLElement[]
  ) {
    await this.animate(
      mountainBg,
      { left: "-100%", width: "425px" },
      { left: "-123px", width: "220%" },
      {
        duration: this.hasAnimate ? 800 : 0,
        easing: "ease"
      }
    );
    this.animate(
      mountainBg,
      { width: "220%" },
      { width: "425px" },
      { duration: this.hasAnimate ? 500 : 0, easing: "ease-out" }
    );
    this.animate(
      this.$refs.deepBlue as HTMLElement,
      { opacity: 0 },
      { opacity: 1 },
      { duration: this.hasAnimate ? 500 : 0, easing: "ease", fill: "forwards" }
    );
    await this.animate(
      midImg,
      { opacity: 0 },
      { opacity: 1 },
      { duration: this.hasAnimate ? 500 : 0, easing: "ease", fill: "forwards" }
    );
    this.getItemTimeline(iceItem);
  }

  async getItemTimeline(iceItem: HTMLElement[]) {
    for (let i = 0; i < iceItem.length; i++) {
      iceItem[i].classList.remove("select-target");
      this.animate(
        iceItem[i],
        { transform: "translateX(68px)", opacity: 0 },
        { transform: "translateX(0)", opacity: 1 },
        {
          duration: this.hasAnimate ? 300 : 0,
          easing: "ease",
          fill: "forwards",
          delay: this.hasAnimate ? 120 * i : 0
        }
      );
    }
    if (this.hasAnimate) {
      await this.sleep(700);
    }
    for (let i = 0; i < iceItem.length; i++) {
      if (this.currentIndex === i) {
        iceItem[i].classList.add("select-target");
      }
    }
    this.$emit("finish");
  }

  async sleep(time: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(1);
      }, time);
    });
  }

  async startAnimate(
    iceMountain: HTMLElement,
    mountainBg: HTMLElement,
    iceItem: HTMLElement[],
    midImg: HTMLElement
  ) {
    this.startMountainTimeline(iceMountain);
    this.startBgTimeline(mountainBg, midImg, iceItem);
  }

  mounted() {
    this.iceMountain = this.$refs.iceMountain as HTMLElement;
    this.mountainBg = this.$refs.mountainBg as HTMLElement;
    this.iceItem = this.$refs.iceItem as HTMLElement[];
    this.midImg = this.$refs.midImg as HTMLElement;
    this.startAnimate(
      this.iceMountain,
      this.mountainBg,
      this.iceItem,
      this.midImg
    );
    return;
  }
}
